export default "https://cdn-static.gokick.com/assets/1d764bbda6f1db3d5ed96a1ece7edd078534d524/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";